<div class="w-full p-4 m-auto transition-all bg-white shadow-lg font-body md:p-12 rounded-lg">
  <h2 class="mb-4 text-xl font-weight-bold md:text-3xl">
    {{ estimate?.title | translate }}
  </h2>

  @if (npiText) {
    <p class="mb-4 text-sm text-gray-900">{{ npiText }}</p>
  }

  @if (estimateConfig?.disclaimer) {
    <pa-alert [alert]="disclaimerAlert"
    [alertAcknowledged]="estimateConfig?.variables?.['estimateDisclaimerAcknowledged'] ?? estimateDisclaimerAcknowledged"></pa-alert>
  }

  @if (showDetails) {
    @for (serviceGroup of estimateConfig?.serviceGroups; track serviceGroup; let first = $first) {
      <div
        [ngClass]="{ hidden: serviceGroup.providerGroups?.length === 0, 'mt-4': !first }" class="print service-group">
        <service-group-header [serviceGroup]="serviceGroup"></service-group-header>
        @for (providerGroup of serviceGroup.providerGroups; track providerGroup; let last = $last) {
          <div [ngClass]="{ 'mb-6': !last }"
            class="p-4 mb-3 border border-opacity-50 print:provider-group md:p-12 shadow-th-card">
            <provider-group-header [providerGroup]="providerGroup"></provider-group-header>
            <provider-group-services [providerGroup]="providerGroup"></provider-group-services>
            <provider-group-total [providerGroup]="providerGroup"></provider-group-total>
          </div>
        }
        <service-group-total [serviceGroup]="serviceGroup"></service-group-total>
      <selfpay-discount-total [selfpayDiscounts]="
        estimateConfig?.variables?.['accountSelfpays']"></selfpay-discount-total>
      <estimate-notice [message]="estimateConfig?.estimateNoticeMessage"></estimate-notice>
      </div>
    }
  }

  @if (showAcknowledgeRow) {
    <div class="flex flex-col items-center justify-between py-4 my-4 md:flex-row">
      <label for="acknowledgeName" class="sr-only">Enter Full Name</label>
      <input id="acknowledgeName" [(ngModel)]="acknowledgeName" type="text" placeholder="Enter Full Name" aria-label="Enter Full Name"
        class="w-full max-w-full px-3 py-2 my-2 text-base text-gray-900 placeholder-gray-600 border border-gray-500 rounded-sm md:mx-4 md:my-0 md:w-[32rem] lg:w-[40rem] focus:outline-none focus:ring-2 focus:ring-th-primary focus:border-th-primary" />
        <button type="button" (click)="acknowledgeEstimate()" [disabled]="!canAcknowledge"
      [ngClass]="{
        'cursor-not-allowed border-gray-500 text-gray-700 bg-gray-100': !canAcknowledge,
        'text-th-primary bg-white': canAcknowledge
      }"
          class="p-2 py-2 text-xs font-bold border rounded-sm shadow-sm align-items-center justify-content-center md:p-4 md:text-sm">
          @if (!isSubmitting) {
            Acknowledge
          }
          @if (isSubmitting) {
            Submitting...
          }
        </button>
      </div>
    }

    @if (!showAcknowledgeRow) {
      <div
        class="flex flex-col items-center justify-between py-4 my-4 print:estimate-total-resp md:flex-row">
        <div class="font-bold whitespace-nowrap">
          {{ estimate?.summary?.responsibility?.label | translate }}
        </div>
        <div class="text-5xl font-bold whitespace-nowrap">
          {{ estimate?.summary?.responsibility?.value | translate }}
        </div>
        @if (canShowDetails) {
          <a (click)="toggleDetails()"
            class="p-2 py-2 text-xs font-bold border rounded-sm shadow-sm align-items-center justify-content-center md:p-4 text-th-primary md:text-sm cursor-pointer">
            @if (!showDetails) {
              Show Details
            }
            @if (showDetails) {
              Hide Details
            }
          </a>
        }
      </div>
    }
  </div>